export class RequestDetail {
  detail: any;
  realocatable: boolean;
  comments: any[];
  fields: any[];
  internalComments: any[];
  possibleStatus: any[];

  constructor() {
    this.comments = [];
    this.fields = [];
    this.realocatable = false;
    this.detail = {};
    this.internalComments = [];
    this.possibleStatus = [];
  }
}
